requirejs(['/web-templates/assets/public/js/dist/require.config.js?v=1750979650'], function() {
  requirejs(['jquery', 'lodash', 'googleMaps', 'sifter'], function($, _, google, Sifter) {
    window.Sifter = Sifter;
    requirejs(['react', 'react-dom', 'prop-types', 'sessions', 'analyticsIntegrations'],
      function(React, ReactDOM, PropTypes, cookiefn) {
        window.PropTypes = PropTypes;
        cookiefn.defaults = window.PSSessions.Cookies.defaults;
        PSSessions.Cookies = cookiefn;
        window.PSSessions = PSSessions;
        PSSessions.Cookies.expire("PS");

        requirejs(['jqueryMigrate', 'bootstrap', 'cloudinary', 'cloudinaryWidget','react-onclickoutside', 'analyticsIntegrations'],
          function () {
            requirejs(['homepage', 'nav', 'footer'],
              function () {
                analyticsIntegrations.mainFunctionsLoad();
                requirejs(['bugsnag'], function (Bugsnag) {
                  requirejs(['bugsnagTracking'], function () {
                    requirejs(['facebook'], function fbCollections (FB) {
                      if (FB) {
                        window.FB = FB;
                        FB.init({
                          appId: window.facebookID,
                          cookie: true,
                          xfbml: true,
                          version: 'v19.0',
                          status: true
                        });
                      }
                    }, function fbCollError (error) {
                      if (console) {
                        console.log("Content blocker is preventing Peerspace connecting to Facebook.  Please sign up/in via email instead.");
                      }
                    });
                  })
                });
              }
            );
          }
        );
      }
    );
  });
});
